import {
    actionIcSettings24px,
    contentIcArchive24px,
    actionIcAccountCircle24px,
    editorIcBorderColor24px,
    actionIcCopyright24px,
    contentIcAdd24px,
    actionIcCheckCircle24px,
    contentIcContentCopy24px,
    alertIcErrorOutline24px,
    navigationIcCheck24px,
    actionIcDelete24px,
    editorIcModeEdit24px,
    alertIcError24px,
    actionIcDescription24px,
    alertIcWarning24px,
    actionIcInfoOutline24px,
    navigationIcChevronRight24px,
    navigationIcExpandMore24px,
    navigationIcClose24px,
    navigationIcMoreVert24px,
    actionIcSearch24px,
    actionIcOpenWith24px,
    navigationIcExpandLess24px,
    contentIcClear24px,
    actionIcHelpOutline24px
} from '@ey-xd/motif-react/assets/icons';

import {
    deleteIcon,
    downloadIcon,
    editIcon,
    restoreIcon,
    successFilledIcon,
    successOutlinedIcon,
    logoutIcon,
    homeSelectedIcon,
    homeDefaultIcon
} from './custom';

import AddSubCategory from './SubCategory.svg';
import Archive from './Archive.svg';

export const ICON_COLLECTION = {
    IC_Archive: contentIcArchive24px,
    IC_Variants: actionIcSettings24px,
    IC_VRSession: actionIcAccountCircle24px,
    IC_Editors: editorIcBorderColor24px,
    IC_CopyRight: actionIcCopyright24px,
    IC_ContentAdd: contentIcAdd24px,
    IC_File: actionIcDescription24px,
    IC_Info: actionIcInfoOutline24px,
    IC_ChevronRight: navigationIcChevronRight24px,
    IC_ExpandMore: navigationIcExpandMore24px,
    IC_ExpandLess: navigationIcExpandLess24px,
    IC_Edit: editIcon,
    IC_Delete: deleteIcon,
    IC_Setting: navigationIcMoreVert24px,
    IC_Search: actionIcSearch24px,
    IC_Success: actionIcCheckCircle24px,
    IC_Success_Outlined: successOutlinedIcon,
    IC_Success_Filled: successFilledIcon,
    IC_ADD_NEW_CATEGORY: AddSubCategory,
    IC_ArchiveCustom: Archive,
    IC_Copy: contentIcContentCopy24px,
    IC_Download: downloadIcon,
    IC_Move: actionIcOpenWith24px,
    IC_Restore: restoreIcon,
    IC_Logout: logoutIcon,
    IC_Clear: contentIcClear24px,
    IC_Home_Selected: homeSelectedIcon,
    IC_Home_Default: homeDefaultIcon,
    IC_Help_Outline: actionIcHelpOutline24px
};

export {
    alertIcError24px,
    actionIcCheckCircle24px,
    contentIcContentCopy24px,
    alertIcErrorOutline24px,
    navigationIcCheck24px,
    actionIcDelete24px,
    contentIcArchive24px,
    editorIcModeEdit24px,
    alertIcWarning24px,
    navigationIcClose24px
};
